import { loyalty as base } from './base';
import { loyalty as HU } from './HU';

export const featureConfigMap = {
    base,
    HU,
};
